'use client';
import { isBrowser } from '@s7/platform';
import { noop } from '@s7/utils';

const storage = isBrowser ? window.sessionStorage : {
    setItem: noop,
    getItem: noop
};
const SessionStorageCache = {
    clientOnly: true,
    set: (key, value)=>storage.setItem(key, JSON.stringify(value)),
    get: (key)=>{
        const data = storage.getItem(key);
        return data ? JSON.parse(data) : null;
    }
};

export { SessionStorageCache };
//# sourceMappingURL=session-storage-cache.js.map
